import { alpha, useTheme } from "@mui/material";
import React, { CSSProperties } from "react";

const DialogContainer = ({
  children,
  close,
}: {
  children: React.ReactNode;
  close: () => void;
}) => {
  const theme = useTheme();
  const defaultBackdropMuiStyles =
    typeof theme.components?.MuiBackdrop?.styleOverrides?.root === "object"
      ? (theme.components?.MuiBackdrop?.styleOverrides?.root as CSSProperties)
      : undefined;
  const backdropColor =
    defaultBackdropMuiStyles?.backgroundColor ??
    alpha(theme.palette.common.black, 0.2);
  return (
    <div className="bc-fixed bc-z-50 bc-inset-0 bc-flex bc-items-center bc-justify-center bc-overflow-hidden">
      <div className="bc-fixed bc-inset-0 bc-transition-opacity">
        <div
          className="bc-absolute !bc-flex bc-inset-0"
          style={{ backgroundColor: backdropColor }}
          onClick={close}
        ></div>
      </div>
      {children}
    </div>
  );
};

export default DialogContainer;
